import React from "react";
import {ContractType, RateType} from "../../../store/NewEmployeeWizardState";
import {trans} from "../../../locale/utils";


export const salaryAmountLabelWithBrackets = (rateType?: RateType) => {
    if (rateType) {
        return <>({salaryAmountLabel(rateType)})</>
    }
    return "";
}

export const salaryAmountLabel = (rateType?: RateType) => {
    if (rateType) {
        if (rateType === RateType.MONTHLY) {
            return trans("new_employee.contract_details.rate_per_month", "EUR per month")
        } else {
            return trans("new_employee.contract_details.rate_per_hour", "EUR per hour")
        }
    }
    return "";
}

export const contractTypeLabel = (type: ContractType) => {
    switch (type) {
        case ContractType.EMPLOYMENT:
            return trans("new_employee.contract_details.contract_employment", "Employment");
        case ContractType.BOARD_MEMBER:
            return trans("new_employee.contract_details.contract_board", "Board member");
    }
}